import './designContainer.scss';
import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { DesignContainerVM } from './DesignContainerVM';
import { LeftSideMenu } from '../LeftSideMenu/LeftSideMenu';
import { Switch, Route, useRouteMatch, useHistory, useParams } from 'react-router-dom';
import { DesignTabContainer } from '../DesignTabContainer/DesignTabContainer';
import stores from '../../../models/Stores';
import { ProjectPanel } from '../ProjectPanel';
import { SurfaceDesigner } from '../SurfaceDesigner/SurfaceDesigner';
import { extent32, point16, circle16F, plus16 } from "@esri/calcite-ui-icons";
import {
  DualEsriView,
  DualEsriViewModel,
  IDualEsriViewModelConstructorProps,
  ViewStyleEnum,
} from 'cd-eft/components/common/mapping';
import {
  Map,
  MapView,
  SceneView,
  Compass,
  Home,
  BasemapGallery,
  Expand,
  LayerList,
  Search,
  ImageryLayer
} from 'cd-eft/utils/esriTypes';
import { SurfaceDesignerVm } from '../SurfaceDesigner/SurfaceDesignerVm';
import { AlignmentContainer } from '../alignment/AlignmentContainer/AlignmentContainer';
import { PitSummary } from '../PitSummary';
import { NewPit } from '../NewPit';
import { PadSummary } from '../PadSummary';
import { NewPad } from '../NewPad';
import { LandLevelingSummary } from '../LandLevelingSummary';
import { NewLandLeveling } from '../NewLandLeveling';
import { EngineeringMapService } from 'cd-eft/framework/mapServices/EngineeringMapServices';
import Point from '@arcgis/core/geometry/Point';
import Viewpoint from '@arcgis/core/Viewpoint';
import Camera from '@arcgis/core/Camera';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { UnderConstruction } from 'cd-eft/components/common/UnderConstruction';
import { PendingEditManager } from 'cd-eft/components/Design/common/PendingEditManager/PendingEditManager';
import { CrossSectionManager } from '../CrossSection/CrossSectionManager';
import { WDTContainer } from '../Waterway/WDTContainer/WDTContainer';
import PortalBasemapsSource from '@arcgis/core/widgets/BasemapGallery/support/PortalBasemapsSource';
import BaseMap from '@arcgis/core/Basemap';
import ImageryTileLayer from '@arcgis/core/layers/ImageryTileLayer';
import { WaterwaySizingMini } from '../Waterway/WaterwaySizingMini';
import ScaleBar from '@arcgis/core/widgets/ScaleBar';
import { mdiCamera } from '@mdi/js';
import { ScreenshotPreview } from 'cd-eft/components/common/Screenshot/ScreenshotPreview';
import { ScreenshotPreviewVM } from 'cd-eft/components/common/Screenshot/ScreenshotPreviewVM';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { TerraceContainer } from '../Terrace/TerraceContainer/TerraceContainer';
import { TerraceSummary } from '../Terrace/Terrace Summary/TerraceSummary';
import { UGOPages } from '../UGO/UGOContainer/UGOContainer';
import { IPendingEditManagerVMConstructorProps } from 'cd-eft/components/common/PendingEditManager/PendingEditManagerVM';


const { designStore, appConfig, userProfileStore, waterwayDesignStore, projectsLibraryStore } = stores.AppStore;

const DesignContainerComponent = (props: any) => {
  const screenshotPreview = useRef<ScreenshotPreviewVM>(new ScreenshotPreviewVM()).current;
  //initialize the DualEsriViewModel
  const history = useHistory();
  // const location = useLocation();
  const vmREF = useRef<DesignContainerVM>();
  if (!vmREF.current) {
    vmREF.current = new DesignContainerVM(history);
  }
  const mapViewRef = useRef<MapView>();

  const vm = vmREF.current;
  const { path } = useRouteMatch();
  const { projectId }: any = useParams();

  //// this is temporary location for this DualEsriViewModel related code,
  //// it should be refactored further up in the state heirarchy to enable being able to preserve the stateful props
  //// even when moving away from the current page
  const dualEsriViewModelREF = useRef<DualEsriViewModel>();

  const icon = document.createElement("i");
  icon.id = "snapping-button";
  icon.innerHTML = `
      <div id="snap-message">${vm.snapMessage}</div>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" style="fill: #6e6e6e;" viewBox="0 0 35 35" class="icon-extent24">
          <path d="${extent32}" />
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style="fill: #6e6e6e;" class="icon-point16">
          <path d="${point16}" />
      </svg>`

  const updateIcon = () => {
    const snapIcon = document.getElementById("snapping-button");
    if (snapIcon) {
      snapIcon.innerHTML = `
      <div id="snap-message" class="${designStore.snappingEnabled ? ' visible' : ""}">${vm.snapMessage}</div>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" style="fill: #6e6e6e;" viewBox="0 0 35 35" class="icon-extent24">
          <path d="${extent32}" />
      </svg>
      ${!designStore.snappingEnabled ?
          `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style="fill: #6e6e6e;" class="icon-point16">
          <path d="${point16}" />
        </svg>`
          :
          `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style="fill: #6e6e6e;"  viewBox="0 0 33 33" class="icon-circle16F">
          <path d="${circle16F}" />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style="fill: #6e6e6e;" viewBox="0 0 19 19" class="icon-plus16 ">
          <path d="${plus16}" />
        </svg>`
        }
    `;
    }
  };

  if (!dualEsriViewModelREF.current) {
    vm.setProjectId(projectId)
    // const map = new Map({ basemap: 'gray' }); //exclude 3D elevation data
    const map = new Map({ basemap: 'gray-vector', ground: 'world-elevation' }); //include 3D elevation data
    map.ground.opacity = 0.5;
    map.ground.navigationConstraint = { type: 'none' };

    const mapViewA = new MapView({
      map: map,
      center: [-100, 40], // CONTINENTAL US
      zoom: 4, // CONTINENTAL US
    });

    const compassWidgetA = new Compass({ view: mapViewA });
    mapViewA.ui.add({ component: compassWidgetA, position: 'top-left' });

    const sceneViewB = new SceneView({
      map: map,
      center: [-100, 40], // CONTINENTAL US
      zoom: 4, // CONTINENTAL US
    });

    const dualViewProps: IDualEsriViewModelConstructorProps = {
      viewStyle: ViewStyleEnum.corner,
      viewA: mapViewA,
      viewB: sceneViewB,
      mouseTracking: true,
      viewpointTracking: true,
      viewpointSynching: true,
    };

    const dualViewModel = new DualEsriViewModel(dualViewProps);
    ///create reference
    const homeWidget = new Home({ view: mapViewA });
    vm.homeWidget = homeWidget;
    designStore.homeWidget = homeWidget; //stash homeWidget in the designStore for other modules to access
    // implement "home" action when scene view is active
    designStore.homeWidget.on('go', function () {
      if (vm.sceneView && designStore.homeWidget!.viewpoint && designStore.homeWidget!.viewpoint.targetGeometry && designStore.homeWidget!.viewpoint.targetGeometry.extent) {
        const targetGeometry = designStore.homeWidget!.viewpoint.targetGeometry.extent;

        const centerX = (targetGeometry.xmax + targetGeometry.xmin) / 2.0;
        const centerY = (targetGeometry.ymax + targetGeometry.ymin) / 2.0;
        const sumSides = targetGeometry.xmax - targetGeometry.xmin + targetGeometry.ymax - targetGeometry.ymin;
        const cameraPoint = new Point({
          hasZ: true,
          x: centerX,
          y: centerY,
          z: sumSides * 1.5,
          spatialReference: targetGeometry.spatialReference,
        });
        const sceneCamera = new Camera({ position: cameraPoint });

        vm.sceneView.goTo(sceneCamera).then(() => {
          if (designStore.sceneViewActive) {
            const fullExtent = targetGeometry.clone();
            fullExtent.expand(1.63); // to match the original scene extent
            const sceneViewpoint = new Viewpoint({
              targetGeometry: fullExtent,
              rotation: 0,
            });
            vm.sceneView!.goTo(sceneViewpoint);
          } else if (vm.view) {
            vm.view.goTo(designStore.homeWidget!.viewpoint.targetGeometry.extent);
          }
        });
      }
    });

    const layerList = new LayerList({ view: mapViewA });
    const layerListWidget = new Expand({
      view: mapViewA,
      content: layerList,
      expandTooltip: 'Layer List',
      collapseTooltip: 'Layer List',
      group: 'top-left',
    });
    designStore.layerListWidget = layerListWidget;

    const aoiLocator = new Search({ view: mapViewA });
    const aoiWidget = new Expand({
      view: mapViewA,
      content: aoiLocator,
      expandTooltip: 'AOI Locator',
      collapseTooltip: 'AOI Locator',
      group: 'top-left',
    });

    //const basemapGallery = new BasemapGallery({ view: mapViewA }); //This is default arcGIS baseMapGallery

    //The following code adds a custom basemap to the basemapGallery
    //The code hides basemap "NAIP Imagery Hybrid" and then add NAIP
    // imagery of USDA( as its more updated than in the Gallery)
    const NAIPLayerTiled = new ImageryTileLayer({ url: appConfig.usdaNaipSources.baseMapPath });
    const NAIPLayerNonTiled = new ImageryLayer({ url: appConfig.usdaNaipSources.nonTiledPath });
    const NAIPBaseMapTiled = new BaseMap({
      baseLayers: [NAIPLayerTiled],
      title: "NAIP Imagery (USDA)",
      thumbnailUrl: appConfig.usdaNaipSources.thumbnailPath
    });
    const NAIPBaseMapNonTiled = new BaseMap({
      baseLayers: [NAIPLayerNonTiled],
      title: "NAIP Imagery (USDA)",
      thumbnailUrl: appConfig.usdaNaipSources.thumbnailPath
    });
    let displayNAIPTiled = false;
    const portalBasemapSource = new PortalBasemapsSource({
      portal: {
        url: "https://www.arcgis.com"
      },
      filterFunction: function (basemap) {
        //hides NAIP Imagery from the Gallery
        return basemap.portalItem.title !== "NAIP Imagery Hybrid";
      },
      updateBasemapsCallback: function (items) {
        // add basemap to the array
        items.unshift(NAIPBaseMapNonTiled);
        // return the array of basemaps
        return items;
      }
    });

    const basemapGallery = new BasemapGallery({
      source: portalBasemapSource,
      view: mapViewA
    });

    const basemapGalleryWidget = new Expand({
      view: mapViewA,
      content: basemapGallery,
      expandTooltip: 'Basemap Gallery',
      collapseTooltip: 'Basemap Gallery',
      group: 'top-left',
    });

    designStore.basemapGalleryWidget = basemapGalleryWidget;

    mapViewA.watch('scale', (newValue) => {
      if (newValue < 4600 && displayNAIPTiled) {
        if (mapViewA.map.basemap.title === 'NAIP Imagery (USDA)') {
          mapViewA.map.basemap = NAIPBaseMapNonTiled;
        }
        displayNAIPTiled = false;
      } else if (newValue >= 4600 && !displayNAIPTiled) {
        if (mapViewA.map.basemap.title === 'NAIP Imagery (USDA)') {
          mapViewA.map.basemap = NAIPBaseMapTiled;
        }
        displayNAIPTiled = true;
      }
    })

    const synchToggle = new Expand({
      expandTooltip: 'Synchronize Viewports',
      collapseTooltip: 'Synchronize Viewports',
      expandIconClass: 'esri-icon-link-horizontal',
      collapseIconClass: 'esri-icon-unlocked-link-horizontal',
      group: 'top-left',
    });
    synchToggle.watch('expanded', function (this: Expand) {
      //note: "this" refers to the Expand widget instance
      dualViewModel.viewpointSynching = !this.expanded;
    });

    const rotate3DView = (direction: number) => {
      let heading = 0;
      let dir = direction;

      if (designStore.sceneViewActive) {
        heading = sceneViewB.camera.heading;
        dir = direction * -1;
      }
      else {
        heading = mapViewA.rotation;
      }

      // Set the heading of the view to the closest multiple of 90 degrees,
      // depending on the direction of rotation
      if (dir > 0) {
        heading = Math.floor((heading + 1e-3) / 90) * 90 + 90;
      } else {
        heading = Math.ceil((heading - 1e-3) / 90) * 90 - 90;
      }

      if (designStore.sceneViewActive) {
        sceneViewB
          .goTo({
            heading: heading,
          })
          .catch((error) => {
            if (error.name != 'AbortError') {
              console.error(error);
            }
          });
      }
      else {
        mapViewA.rotation = heading;
      }

    }

    const rotateCW = new Expand({
      expandTooltip: 'Rotate Clockwise',
      collapseTooltip: 'Rotate Clockwise',
      expandIconClass: 'esri-icon-rotate',
      collapseIconClass: 'esri-icon-rotate',
    });
    rotateCW.watch('expanded', function (this: Expand) {
      rotate3DView(1);
    });

    const rotateCCW = new Expand({
      expandTooltip: 'Rotate Counter Clockwise',
      collapseTooltip: 'Rotate Counter Clockwise',
      expandIconClass: 'esri-icon-rotate-back',
      collapseIconClass: 'esri-icon-rotate-back',
    });
    rotateCCW.watch('expanded', function (this: Expand) {
      rotate3DView(-1);
    });

    const viewSwitcher = new Expand({
      expandTooltip: 'Switch Primary Viewport',
      collapseTooltip: 'Switch Primary Viewport',
      expandIconClass: 'esri-icon-public',
      collapseIconClass: 'esri-icon-maps',
      group: 'top-left',
    });
    const snapToPoint = document.createElement("button");
    snapToPoint.setAttribute("id", "snap-to-point-button");
    snapToPoint.setAttribute("aria-label", "snap to point");
    snapToPoint.className = "esri-widget--button snap-to-point";

    snapToPoint.appendChild(icon);
    document.body.appendChild(snapToPoint);

    snapToPoint.addEventListener("click", function () {
      if (designStore.currentSurface.surfaceDefClassName !== 'survey') {
        return;
      }
      designStore.snappingEnabled = !designStore.snappingEnabled;
      updateIcon();
      vm.toggleSnapping();
      vm.toggleChildSnapping();
      vm.toggleSurveyPointLayer();
    });

    // screenshot tool
    const iconPath = mdiCamera;

    const takeScreenshot = document.createElement("button");
    takeScreenshot.title = 'Take Screenshot';
    takeScreenshot.className = "esri-widget--button snap-to-point";

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '24'); // Adjust icon size
    svg.setAttribute('height', '24');
    svg.setAttribute('style', 'fill: #6e6e6e');

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', iconPath);
    svg.appendChild(path);
    takeScreenshot.appendChild(svg);
    document.body.appendChild(takeScreenshot);

    takeScreenshot.addEventListener('click', function () {
      DesignContainerVM.takeScreenshot(stores.AppStore.designStore.sceneViewActive, screenshotPreview);
    });

    // layers widget
    layerListWidget.watch('expanded', function (this: Expand) {
      surfaceDesignerVm.closeToolBar(designStore.designElementTypeId, designStore.currentSurface.surfaceDefClassName);
    });
    basemapGalleryWidget.watch('expanded', function (this: Expand) {
      surfaceDesignerVm.closeToolBar(designStore.designElementTypeId, designStore.currentSurface.surfaceDefClassName);
    });

    const scaleBar = new ScaleBar({
      view: dualViewModel.primaryView,
      id: 'scale-ruler',
      style: 'ruler',
      unit: 'metric'
    });
    dualViewModel.primaryView.ui.add(scaleBar, 'bottom-left');

    viewSwitcher.watch('expanded', function (this: Expand) {
      stores.AppStore.designStore.sceneViewActive = !stores.AppStore.designStore.sceneViewActive;
      //note: "this" refers to the Expand widget instance
      dualViewModel.switchPrimaryView = this.expanded;
      dualViewModel.primaryView.ui.add({ component: snapToPoint, position: 'top-left', index: 1 });
      dualViewModel.primaryView.ui.add({ component: viewSwitcher, position: 'top-left', index: 2 });
      dualViewModel.primaryView.ui.add({ component: synchToggle, position: 'top-left', index: 3 });
      dualViewModel.primaryView.ui.add({ component: takeScreenshot, position: 'top-left', index: 4 });
      dualViewModel.primaryView.ui.add({ component: basemapGalleryWidget, position: 'top-left', index: 5 });
      dualViewModel.primaryView.ui.add({ component: layerListWidget, position: 'top-left', index: 6 });
      dualViewModel.primaryView.ui.add({ component: homeWidget, position: 'top-left', index: 7 });
      dualViewModel.primaryView.ui.add({ component: rotateCW, position: 'top-left', index: 8 });
      dualViewModel.primaryView.ui.add({ component: rotateCCW, position: 'top-left', index: 9 });
      dualViewModel.primaryView.ui.add({ component: aoiWidget, position: 'top-left', index: 10 });

      DesignContainerVM.setTinVisibility(stores.AppStore.designStore.sceneViewActive);
    });

    dualViewModel.primaryView.ui.add({ component: snapToPoint, position: 'top-left', index: 1 });
    dualViewModel.primaryView.ui.add({ component: viewSwitcher, position: 'top-left', index: 2 });
    dualViewModel.primaryView.ui.add({ component: synchToggle, position: 'top-left', index: 3 });
    dualViewModel.primaryView.ui.add({ component: takeScreenshot, position: 'top-left', index: 4 });
    dualViewModel.primaryView.ui.add({ component: basemapGalleryWidget, position: 'top-left', index: 5 });
    dualViewModel.primaryView.ui.add({ component: layerListWidget, position: 'top-left', index: 6 });
    dualViewModel.primaryView.ui.add({ component: homeWidget, position: 'top-left', index: 7 });
    dualViewModel.primaryView.ui.add({ component: rotateCW, position: 'top-left', index: 8 });
    dualViewModel.primaryView.ui.add({ component: rotateCCW, position: 'top-left', index: 9 });
    dualViewModel.primaryView.ui.add({ component: aoiWidget, position: 'top-left', index: 10 });

    //turn these off until we figure out how to prevent them from interfering with mouse clicks
    dualViewModel.viewpointTracking = false;
    dualViewModel.mouseTracking = false;

    dualEsriViewModelREF.current = dualViewModel;
    mapViewRef.current = mapViewA;

    EngineeringMapService.Load(mapViewA);

    vm.onMapViewMounted(mapViewA);
    vm.onSceneViewMounted(sceneViewB);
  }

  const surfaceDesignerVmRef = useRef<SurfaceDesignerVm>();

  if (!surfaceDesignerVmRef.current) {
    const vmProps = {
      mapView: mapViewRef.current!,
      toolSlot: vm.toolSlot,
      component: "Design"
    } as IPendingEditManagerVMConstructorProps;
    surfaceDesignerVmRef.current = new SurfaceDesignerVm(vmProps);
  }
  const surfaceDesignerVm: SurfaceDesignerVm = surfaceDesignerVmRef.current;

  // mount/unmount
  useEffect(function mount() {
    function unmount() {
      designStore.snappingEnabled = false;
      updateIcon();
      dualEsriViewModelREF.current!.switchPrimaryView = false;
      const mapViewA = dualEsriViewModelREF.current?.primaryView as MapView;
      const sceneViewB = dualEsriViewModelREF.current?.secondaryView as SceneView;
      dualEsriViewModelREF.current!.dispose();
      sceneViewB.destroy();
      mapViewA.destroy();
      MessageCenter.clearMessages();
      dualEsriViewModelREF.current = undefined;
      vmREF.current = undefined;
      stores.AppStore.designStore.reset();
      stores.AppStore.designStore.projectsStore.reset();
      stores.AppStore.surveyEngineeringStore.reset();
      vm._snapTooltipProvider?.Dispose();
      waterwayDesignStore.renderWaterwayDesign = false;
      waterwayDesignStore.currentWorkflowStep = "waterway-input";
      projectsLibraryStore.resetZValue = false;
    }
    return unmount;
  }, []); // important, only run mount/unmount functions once to manage the map lifecycle

  // useEffect(() => {
  //   designStore.isLoading = true;
  //   vm.initializeDesignFlow();
  // }, []);

  useEffect(() => {
    const btn = document.getElementById("snap-to-point-button");
    if (designStore.currentSurface.surfaceDefClassName === 'dem') {
      if (btn) btn!.setAttribute('style', 'display: none');
    } else {
      if (btn) btn!.setAttribute('style', 'display: block');
    }
  }, [designStore.currentSurface.surfaceDefClassName]);

  return (
    <div className="design-container" id="design-container">
      {DesignContainerVM.screenshotLoading && <Loader message={'Taking screenshot...'} />}
      <ScreenshotPreview vm={screenshotPreview}></ScreenshotPreview>
      <LeftSideMenu />
      <div className="design-workspace">
        {/* <div className="design-mapping" hidden={window.location.href.includes('/design/surface')}> */}
        <div className="design-mapping">
          <DualEsriView vm={dualEsriViewModelREF.current} />
        </div>
        {/* <div>
          <Fragment>
            <DemIntegration mapView={vm.view} project_class_id={1} parentVm={vm} />
          </Fragment>
        </div> */}
        {vm.view && (
          <div className="design-designers">
            <PendingEditManager vm={surfaceDesignerVm} toolSlot={props.toolSlot} />
            <CrossSectionManager updateSnapIcon={updateIcon} toggleSnapping={vm.toggleSnapping} />
            <Route path={path} component={() => <ProjectPanel />} />
            <Switch>
              {/* <Route path={`${path}/surface`} component={SETContainer} /> */}
              <Route
                path={`${path}/surface`}
                render={() => {
                  surfaceDesignerVm.setDesignElementToolbar(appConfig.hardCodes.designElementTypeSuface.toString())
                  return userProfileStore.applicationFlags.enablesurface ? (
                    <SurfaceDesigner vm={surfaceDesignerVm} toolSlot={vm.toolSlot} designREF={vm} updateSnapIcon={updateIcon} toggleSnapping={vm.toggleSnapping} />
                  ) : (
                    <UnderConstruction tool='design' title={'Surface Design'} activeDev={true} />
                  )
                }
                }
              ></Route>
              <Route
                path={`${path}/pit`}
                component={() => {
                  surfaceDesignerVm.setDesignElementToolbar(appConfig.hardCodes.designElementTypePitRectangular.toString())
                  return userProfileStore.applicationFlags.enablepit ? (
                    <DesignTabContainer
                      mapView={vm.view}
                      store={stores.AppStore.pitDesignStore}
                      title="Pit Design"
                      summaryComponent={
                        <PitSummary mapView={vm.view} applyPitStructuresToMap={vm.applyPitStructuresToMap} />
                      }
                      editFormComponent={
                        <NewPit
                          mapView={vm.view}
                          drawBaseGraphic={vm.drawBaseGraphic}
                          updateBaseGraphic={vm.updateBaseGraphic}
                          removeBaseStructureGraphics={vm.removeBaseStructureGraphics}
                          removeCenterMarker={vm.removeCenterMarker}
                          chooseCenterPoint={vm.chooseCenterPoint}
                          redefineSketch={vm.redefineSketch}
                        />
                      }
                    />
                  ) : (
                    <UnderConstruction tool='design' title={'Pit Design'} activeDev={true} />
                  )
                }
                }
              />
              <Route
                path={`${path}/alignment`}
                component={() => {
                  surfaceDesignerVm.setDesignElementToolbar(appConfig.hardCodes.designElementTypeIndependent.toString())
                  return userProfileStore.applicationFlags.enablealignment ? (
                    <AlignmentContainer setCallables={vm.setChildCallables} />
                  ) : (
                    <UnderConstruction tool='design' title={'Alignment Design'} activeDev={true} />
                  )
                }
                }
              />

              <Route path={`${path}/terrace/:terraceId`}
                component={() => {
                  surfaceDesignerVm.setDesignElementToolbar(appConfig.hardCodes.designElementTypeTerrace.toString())
                  return userProfileStore.applicationFlags.enableterrace ? (
                    <TerraceContainer addTerraceEdits={surfaceDesignerVm.addTerraceEdits} />
                  ) : (
                    <UnderConstruction tool='design' title={'Terrace Design'} activeDev={true} />
                  )
                }
                }
              />
              <Route path={`${path}/terrace`}
                exact
                component={() => {
                  surfaceDesignerVm.setDesignElementToolbar(appConfig.hardCodes.designElementTypeTerrace.toString())
                  return userProfileStore.applicationFlags.enableterrace ? (
                    <TerraceSummary />
                  ) : (
                    <UnderConstruction tool='design' title={'Terrace Design'} activeDev={true} />
                  )
                }
                }
              />

              <Route path={`${path}/ugo`}
                component={() => {
                  surfaceDesignerVm.setDesignElementToolbar(appConfig.hardCodes.designElementTypeUGO.toString())
                  return userProfileStore.applicationFlags.enableugo ? (
                    <UGOPages addUgoEdits={surfaceDesignerVm.addUgoEdits} />
                  ) : (
                    <UnderConstruction tool='design' title={'UGO Design'} activeDev={true} />
                  )
                }
                }
              />

              <Route
                path={`${path}/waterway`}
                component={() => {
                  surfaceDesignerVm.setDesignElementToolbar(appConfig.hardCodes.designElementTypeWaterway.toString())
                  return userProfileStore.applicationFlags.enablewaterway ? (
                    // <WaterwayPreview/>
                    <>
                      <WDTContainer title={'Waterway Inputs'} addWDTEdits={surfaceDesignerVm.addWDTEdits} saveReachEdits={surfaceDesignerVm.saveReachEdits} resetPEMReachEdits={surfaceDesignerVm.clearWDTReachesSyncStatus} retriveFlowCalculationResults={surfaceDesignerVm.retriveFlowCalculationResults} clearAiTrainingEdits={surfaceDesignerVm.clearWDTReachesSyncStatus} />
                      <WaterwaySizingMini surfaceDesignerVm={surfaceDesignerVm} />
                    </>
                  ) : (
                    <UnderConstruction tool='design' title={'Waterway Design'} activeDev={true} />
                  )
                }
                }
              />
              <Route path={`${path}/pond`} render={() => {
                surfaceDesignerVm.setDesignElementToolbar('-1')
                return <UnderConstruction tool='design' title={'Pond'} />
              }} />
              <Route path={`${path}/pipeline`} render={() => {
                surfaceDesignerVm.setDesignElementToolbar('-1')
                return <UnderConstruction tool='design' title={'Pipeline'} />
              }} />
              <Route
                path={`${path}/pad`}
                component={() => {
                  surfaceDesignerVm.setDesignElementToolbar(appConfig.hardCodes.designElementTypePad.toString())
                  return userProfileStore.applicationFlags.enablepad ? (
                    <DesignTabContainer
                      mapView={vm.view}
                      store={stores.AppStore.padDesignStore}
                      title="Pad Design"
                      summaryComponent={
                        <PadSummary mapView={vm.view} applyPadStructuresToMap={vm.applyPadStructuresToMap} />
                      }
                      editFormComponent={
                        <NewPad
                          mapView={vm.view}
                          drawRectangularBase={vm.drawRectangularPit}
                          updateBaseGraphic={vm.updateRectanglePit}
                          removeBaseStructureGraphics={vm.removeBaseStructureGraphics}
                          removeCenterMarker={vm.removeCenterMarker}
                          chooseCenterPoint={vm.chooseCenterPoint}
                          redefineSketch={vm.redefineSketch}
                        />
                      }
                    />
                  ) : (
                    <UnderConstruction tool='design' title={'Pad Design'} activeDev={true} />
                  )
                }
                }
              />
              <Route
                path={`${path}/land-leveling`}
                component={() => {
                  surfaceDesignerVm.setDesignElementToolbar(appConfig.hardCodes.designElementTypeLandLeveling.toString())
                  return userProfileStore.applicationFlags.enablelandleveling ? (
                    <DesignTabContainer
                      mapView={vm.view}
                      store={stores.AppStore.landLevelingDesignStore}
                      title="Land Leveling Design"
                      summaryComponent={<LandLevelingSummary mapView={vm.view} />}
                      editFormComponent={
                        <NewLandLeveling
                          mapView={vm.view}
                          sketchWidget={vm.sketchWidget}
                          bpSkectchWidget={vm.bpSketchWidget}
                          setCallables={vm.setChildCallables}
                        />
                      }
                    />
                  ) : (
                    <UnderConstruction tool='design' title={'Land Leveling Design'} activeDev={true} />
                  )
                }
                }
              />
            </Switch>
          </div>
        )}
      </div>
    </div>
  );
};

export const DesignContainer = observer(DesignContainerComponent);
